import { API, graphqlOperation } from 'aws-amplify'
import classNames from 'classnames'
import React from 'react'
import { useCallback } from 'react'
import { PlaidLinkOnSuccess, usePlaidLink } from 'react-plaid-link'
import { useHistory } from 'react-router'

import { AddAccountPaths } from '../../config/routes'
import * as errorMessages from '../../errorMessages.json'
import { SupportedErrors } from '../../errorTypes'
import { exchangePublicToken } from '../../graphql/mutations'
import { useAmplitude } from '../../hooks/use-amplitude'
import { Notify } from '../../lib/helpers'
import { Button } from '../button'

export interface PlaidButtonProps {
    /** The link gotten from the getLinkToken query */
    linkToken?: string
    /** This function handles the handoff of the generated accounts to it's father **/
    saveAccounts(accounts: any): void
    /** This prop allows the component to know if it should render a button or a link if the user does not have any account in its account **/
    firstAccount?: boolean
    /** Render loading from outside */
    onLoading: (loading: boolean) => void
    onFinish?: () => void
}

/**
 * Plaid button built over the default button
 */
export function PlaidButton({
    linkToken,
    saveAccounts,
    firstAccount,
    onLoading,
    onFinish = () => {},
}: PlaidButtonProps) {
    const { log } = useAmplitude()

    const onSuccess = React.useCallback<PlaidLinkOnSuccess>(
        async (publicToken: string, metadata) => {
            try {
                onLoading(true)
                // send publicToken to server
                const APIResponse: any = await API.graphql(
                    graphqlOperation(exchangePublicToken, {
                        publicToken,
                        institutionData: {
                            id: metadata.institution?.institution_id,
                            name: metadata.institution?.name,
                        },
                    }),
                )
                onLoading(false)
                saveAccounts(APIResponse.data.exchangePublicToken.balances)
                Notify(
                    'success',
                    'Yippee!',
                    'Your plaid account has been saved',
                )
                onFinish()
                log('NEW_PLAID_ACCOUNT_SUCCESS', {
                    balances: APIResponse.data.exchangePublicToken.balances,
                })
            } catch (e: any) {
                const errorKey: SupportedErrors = e.error
                const message =
                    e && errorKey && errorMessages[errorKey]
                        ? errorMessages[errorKey]
                        : 'Your plaid account could not be saved'
                console.log('Error => ', JSON.stringify(e))
                Notify('danger', 'Whoopsies!', message)

                log('NEW_PLAID_ACCOUNT_FAILED', { error: message })
            }
        },
        [log, onFinish, onLoading, saveAccounts],
    ) // eslint-disable-line react-hooks/exhaustive-deps

    const config: Parameters<typeof usePlaidLink>[0] = {
        token: linkToken!,
        onSuccess,
    }
    const { open } = usePlaidLink(config)
    const history = useHistory()

    const handlePath = useCallback(
        (path: string) => history.push(path),
        [history],
    )

    const buttonStyle = classNames('h-8 text-linkYellow text-left font-bold')

    if (firstAccount) {
        return (
            <div className={'flex flex-col'}>
            <Button className={'h-16 w-64'} onClick={() => open()}>
                {' '}
                + Link an account{' '}
            </Button>
                <button
                    className={`${buttonStyle} mt-10`}
                    onClick={() =>
                        handlePath(AddAccountPaths.ADD_CRYPTO_ACCOUNT)
                    }>
                    {' '}
                    Skip for now{' '}
                </button>
            </div>
        )
    } else {
        return (
            <button
                className={
                    'h-8 text-linkYellow text-left px-2 mb-10 -mt-2 font-bold'
                }
                onClick={() => open()}>
                {' '}
                Link another account{' '}
            </button>
        )
    }
}
